import React from 'react';
import Box from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';
import Container from '@mui/material/Container';
import { SimTypography } from 'components/SimTypography';

import Page from './Page';
import { ParentCoachingDescription } from './ParentCoaching';
import { ParentCommunityDescription } from './ParentCommunity';
import { NannyServicesDescription } from './NannyServices';
import { ParentEdAndSupportDescription } from './ParentEdAndSupport';

import SimSummary from 'components/SimSummary';
import SimVideoScroll from 'components/SimVideoScroll';

const parentEdVideoList = [
	{
		thumb: 'tn1',
		link: 'https://www.youtube.com/embed/XNL9YP8PH7M'
	},
	{
		thumb: 'tn2',
		link: 'https://www.youtube.com/embed/JKDdKrTKWtI'
	},
	{
		thumb: 'tn3',
		link: 'https://www.youtube.com/embed/OIoRltfIYdc'
	},
	{
		thumb: 'tn4',
		link: 'https://www.youtube.com/embed/UgH2FlIuB-Q'
	}
];

const parentCommunityVideoList = [
	{
		thumb: 'tn1',
		link: 'https://www.youtube.com/embed/iGLdkUiQrqc'
	},
	{
		thumb: 'tn2',
		link: 'https://www.youtube.com/embed/EHumaOzKghM'
	},
	{
		thumb: 'tn3',
		link: 'https://www.youtube.com/embed/TqJ2QrJPg-E'
	},
	{
		thumb: 'tn4',
		link: 'https://www.youtube.com/embed/k6gjWDoFqLI'
	}
];

const parentCoachingVideoList = [
	{
		thumb: 'tn1',
		link: 'https://www.youtube.com/embed/AZ8RaX5EuWs'
	},
	{
		thumb: 'tn2',
		link: 'https://www.youtube.com/embed/dS3kwPYa9b8'
	},
	{
		thumb: 'tn3',
		link: 'https://www.youtube.com/embed/wacRhdQWFtI'
	},
	{
		thumb: 'tn4',
		link: 'https://www.youtube.com/embed/WbeiX8vNBnM'
	}
];

const nannyServicesVideoList = [
	{
		thumb: 'tn1',
		link: 'https://www.youtube.com/embed/YnGgCwFUajw'
	},
	{
		thumb: 'tn2',
		link: 'https://www.youtube.com/embed/pnLfcDFKAI4'
	},
	{
		thumb: 'tn3',
		link: 'https://www.youtube.com/embed/3GqcsbzBSlo'
	},
	{
		thumb: 'tn4',
		link: 'https://www.youtube.com/embed/_MgEftvfgzA'
	}
];

const AllParentSupport = () => {
	const theme = useTheme();

	return (
		<Box>
			<Page>
				<Box sx={{ boxShadow: 0 }}>
					<Box>
						<Box position={'relative'} zIndex={2} bgcolor={theme.palette.background.transparentDefault}>
							<Box zIndex={2}></Box>
						</Box>
					</Box>

					<Box paddingY={'30px'}>
						<Container>
							<SimTypography
								sx={{
									textTransform: 'uppercase',
									fontWeight: 'medium'
								}}
								gutterBottom
								color={'secondary'}
								align={'left'}>
								OUR FOUNDERS' NOTE
							</SimTypography>
							<SimTypography
								sx={{
									textTransform: 'uppercase',
									fontWeight: 'medium'
								}}
								color={'secondary'}
								align={'left'}></SimTypography>
							<SimTypography
								variant='h6'
								align={'left'}
								sx={{
									fontWeight: 700,
									fontStyle: 'italic'
								}}>
								As parents, we had to acquire the needed knowledge, support and community engagement
								after many cycles of hope and despair. Our parental education and support services
								catalogue & resource library will help you get a better experience than we did.
							</SimTypography>
						</Container>
					</Box>

					<Box
						id='dividerFinal'
						height={{ xs: '15vh', md: '10vw', lg: '10vw' }}
						marginTop={{ xs: '5vh', sm: '5vw', lg: '5vw' }}>
						<Box
							height={{ xs: '15vh', md: '10vw', lg: '10vw' }}
							component={'svg'}
							preserveAspectRatio='none'
							xmlns='http://www.w3.org/2000/svg'
							x='0px'
							y='0px'
							viewBox='0 0 1920 100.1'
							sx={{
								marginBottom: -1,
								width: 1
							}}>
							<path fill={theme.palette.divider.dark} d='M0,0c0,0,934.4,93.4,1920,0v100.1H0L0,0z'></path>
						</Box>
					</Box>

					<Box id='ANCHOR_ParentServices_ParentEd'>
						<SimSummary
							topTitle='Educating parents for the best developmental outcomes'
							topContent='Understanding a special needs child needs far more than regular parental love and
									care.'
							bottomContent='Explore our parent education offerings'
						/>
						<ParentEdAndSupportDescription />
						<SimVideoScroll videoList={parentEdVideoList} />
					</Box>

					<Box
						id='dividerFinal'
						height={{ xs: '15vh', md: '10vw', lg: '10vw' }}
						marginTop={{ xs: '5vh', sm: '5vw', lg: '5vw' }}>
						<Box
							height={{ xs: '15vh', md: '10vw', lg: '10vw' }}
							component={'svg'}
							preserveAspectRatio='none'
							xmlns='http://www.w3.org/2000/svg'
							x='0px'
							y='0px'
							viewBox='0 0 1920 100.1'
							sx={{
								marginBottom: -1,
								width: 1
							}}>
							<path fill={theme.palette.divider.dark} d='M0,0c0,0,934.4,93.4,1920,0v100.1H0L0,0z'></path>
						</Box>
					</Box>

					<Box id='ANCHOR_ParentServices_Community'>
						<SimSummary
							text='OFFERING'
							topTitle='Building Safe Community Space'
							bottomTitle='for our Precious Ones'
							topContent='Raising a child with special needs can get lonely.'
							bottomContent='Talking to fellow parents & knowing you aren’t alone makes a big difference.'
						/>
						<ParentCommunityDescription />
						<SimVideoScroll videoList={parentCommunityVideoList} />
					</Box>

					<Box
						id='dividerFinal'
						height={{ xs: '15vh', md: '10vw', lg: '10vw' }}
						marginTop={{ xs: '5vh', sm: '5vw', lg: '5vw' }}>
						<Box
							height={{ xs: '15vh', md: '10vw', lg: '10vw' }}
							component={'svg'}
							preserveAspectRatio='none'
							xmlns='http://www.w3.org/2000/svg'
							x='0px'
							y='0px'
							viewBox='0 0 1920 100.1'
							sx={{
								marginBottom: -1,
								width: 1
							}}>
							<path fill={theme.palette.divider.dark} d='M0,0c0,0,934.4,93.4,1920,0v100.1H0L0,0z'></path>
						</Box>
					</Box>

					<Box id='ANCHOR_ParentServices_Coach'>
						<SimSummary
							text='OFFERING'
							topTitle='A personal coach for you helps'
							bottomTitle='your child fight the odds better.'
							topContent='Explore our personalized parental coaching services'
						/>
						<ParentCoachingDescription />
						<SimVideoScroll videoList={parentCoachingVideoList} />
					</Box>

					<Box
						id='dividerFinal'
						height={{ xs: '15vh', md: '10vw', lg: '10vw' }}
						marginTop={{ xs: '5vh', sm: '5vw', lg: '5vw' }}>
						<Box
							height={{ xs: '15vh', md: '10vw', lg: '10vw' }}
							component={'svg'}
							preserveAspectRatio='none'
							xmlns='http://www.w3.org/2000/svg'
							x='0px'
							y='0px'
							viewBox='0 0 1920 100.1'
							sx={{
								marginBottom: -1,
								width: 1
							}}>
							<path fill={theme.palette.divider.dark} d='M0,0c0,0,934.4,93.4,1920,0v100.1H0L0,0z'></path>
						</Box>
					</Box>

					<Box id='ANCHOR_ParentServices_Nanny'>
						<SimSummary
							topTitle='Nanny Services'
							topContent='Raising a special needs child is hard work. Tired of looking for the right nanny?'
							bottomContent='We can help.'
						/>
						<NannyServicesDescription />
						<SimVideoScroll videoList={nannyServicesVideoList} />
					</Box>
				</Box>
			</Page>
		</Box>
	);
};

export { AllParentSupport };
